export default __webpack_public_path__ + "static/Children-Pets-399c9c64222d99ee561fd00f2ef49017.svg";